//create react redux slice for app loader
import { createSlice } from '@reduxjs/toolkit';

interface AppLoaderState {
    isLoading: boolean;
}

const initialState: AppLoaderState = {
    isLoading: false
};

const appLoaderSlice = createSlice({
    name: 'appLoader',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        stopLoading(state) {
            state.isLoading = false;
        }
    }
});

export const { startLoading, stopLoading } = appLoaderSlice.actions;

export default appLoaderSlice.reducer;
